export default "__VITE_ASSET__CAyv69TN__"